import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../envImpairment.module.scss'
import metadata from './UnderwritingInformationComponent.metadata.json5';

import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function UnderwritingInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('UnderwritingInformationComponent');

    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesPleProDet3 : {
            visible : !_.isUndefined(modelVM.value.hasAnyInsEveCanDecOr2) && modelVM.value.hasAnyInsEveCanDecOr2
        },
        ifYesPleProDet5 : {
            visible : !_.isUndefined(modelVM.value.hasTheAppBeeProForCon4) && modelVM.value.hasTheAppBeeProForCon4
        },
        ifYesPleProDet7 : {
            visible : !_.isUndefined(modelVM.value.isTheAppAwaOfAnyFac6) && modelVM.value.isTheAppAwaOfAnyFac6
        },
        ifYesPleProDet10 : {
            visible : !_.isUndefined(modelVM.value.areAnyOfTheCovLocCon1) && modelVM.value.areAnyOfTheCovLocCon1
        },
        ifYesPleProDet19 : {
            visible : !_.isUndefined(modelVM.value.areTheAnyStaOthCit) && modelVM.value.areTheAnyStaOthCit
        },
        ifYesPleProDet9 : {
            visible : !_.isUndefined(modelVM.value.hasTheAppRecAnyFinPen8) && modelVM.value.hasTheAppRecAnyFinPen8
        },
        doYouOrAnyLivUndYou10 : {
            required: true,
            visible : _.get(submissionVM, 'baseData.baseState_Ext.value.code', '') === 'QC'
        },
        ifYesPleProDet12 : {
            visible : !_.isUndefined(modelVM.value.hasTheEveBeeAnyPriHis11) && modelVM.value.hasTheEveBeeAnyPriHis11
        },
        ifYesPleProDet14 : {
            visible : !_.isUndefined(modelVM.value.hasTheAppAnyEmpBeeCha13) && modelVM.value.hasTheAppAnyEmpBeeCha13
        },
        ifYesPleProDet16 : {
            visible : !_.isUndefined(modelVM.value.hasTheAppOrAnyAffEnt15) && modelVM.value.hasTheAppOrAnyAffEnt15
        },
        ifYesPleProDet18 : {
            visible : !_.isUndefined(modelVM.value.havAnyRepChaRelRelClo17) && modelVM.value.havAnyRepChaRelRelClo17
        },
        ifYesPleProDet20 : {
            visible : !_.isUndefined(modelVM.value.areTheAnyPlaToRepCha19) && modelVM.value.areTheAnyPlaToRepCha19
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

UnderwritingInformationComponent.propTypes = wizardProps;
export default withRouter(UnderwritingInformationComponent);
